/* unplugin-vue-components disabled */import __unplugin_components_16 from 'D:/hjj/bio_link_pc/src/components/common/clientProjectDialog.vue';
import __unplugin_components_15 from 'D:/hjj/bio_link_pc/src/components/selectData.vue';
import { ElForm as __unplugin_components_14 } from 'element-plus/es';import 'element-plus/es/components/base/style/css';import 'element-plus/es/components/form/style/css';
import { ElDialog as __unplugin_components_13 } from 'element-plus/es';import 'element-plus/es/components/base/style/css';import 'element-plus/es/components/dialog/style/css';
import { ElUpload as __unplugin_components_12 } from 'element-plus/es';import 'element-plus/es/components/base/style/css';import 'element-plus/es/components/upload/style/css';
import { ElCheckbox as __unplugin_components_11 } from 'element-plus/es';import 'element-plus/es/components/base/style/css';import 'element-plus/es/components/checkbox/style/css';
import { ElIcon as __unplugin_components_10 } from 'element-plus/es';import 'element-plus/es/components/base/style/css';import 'element-plus/es/components/icon/style/css';
import { ElRadioGroup as __unplugin_components_9 } from 'element-plus/es';import 'element-plus/es/components/base/style/css';import 'element-plus/es/components/radio-group/style/css';
import { ElRadio as __unplugin_components_8 } from 'element-plus/es';import 'element-plus/es/components/base/style/css';import 'element-plus/es/components/radio/style/css';
import { ElSelect as __unplugin_components_7 } from 'element-plus/es';import 'element-plus/es/components/base/style/css';import 'element-plus/es/components/select/style/css';
import { ElOption as __unplugin_components_6 } from 'element-plus/es';import 'element-plus/es/components/base/style/css';import 'element-plus/es/components/option/style/css';
import { ElButton as __unplugin_components_5 } from 'element-plus/es';import 'element-plus/es/components/base/style/css';import 'element-plus/es/components/button/style/css';
import { ElInput as __unplugin_components_4 } from 'element-plus/es';import 'element-plus/es/components/base/style/css';import 'element-plus/es/components/input/style/css';
import { ElRow as __unplugin_components_3 } from 'element-plus/es';import 'element-plus/es/components/base/style/css';import 'element-plus/es/components/row/style/css';
import { ElCol as __unplugin_components_2 } from 'element-plus/es';import 'element-plus/es/components/base/style/css';import 'element-plus/es/components/col/style/css';
import { ElFormItem as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/base/style/css';import 'element-plus/es/components/form-item/style/css';
import { ElDatePicker as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/base/style/css';import 'element-plus/es/components/date-picker/style/css';
import _asyncToGenerator from "D:/hjj/bio_link_pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, isRef as _isRef } from "vue";
var _hoisted_1 = {
  style: {
    "display": "flex",
    "width": "100%"
  }
};
var _hoisted_2 = {
  style: {
    "flex": "1"
  }
};
var _hoisted_3 = {
  style: {
    "display": "flex",
    "width": "100%",
    "justify-content": "space-between"
  }
};
var _hoisted_4 = {
  style: {
    "display": "flex",
    "width": "100%"
  }
};
var _hoisted_5 = {
  style: {
    "flex": "1"
  }
};
var _hoisted_6 = {
  class: "clue-list"
};
var _hoisted_7 = {
  class: "clue-row"
};
var _hoisted_8 = {
  class: "clue-inner"
};
var _hoisted_9 = {
  class: "pl-10"
};
var _hoisted_10 = {
  class: "clue-inner"
};
var _hoisted_11 = {
  key: 0,
  class: "clue-inner"
};
var _hoisted_12 = {
  class: "clue-inner"
};
var _hoisted_13 = {
  key: 1,
  class: "clue-inner",
  style: {
    "width": "100%"
  }
};
var _hoisted_14 = {
  key: 2,
  class: "clue-inner"
};
var _hoisted_15 = {
  key: 2,
  class: "bussiness"
};
var _hoisted_16 = {
  class: "clue-row"
};
var _hoisted_17 = {
  class: "clue-inner"
};
var _hoisted_18 = {
  class: "pl-10"
};
var _hoisted_19 = {
  class: "clue-inner"
};
var _hoisted_20 = {
  key: 0,
  class: "clue-inner"
};
var _hoisted_21 = {
  class: "clue-inner"
};
var _hoisted_22 = ["src"];
var _hoisted_23 = {
  class: "dialog-footer"
};
var _hoisted_24 = {
  class: "dialog-footer"
};
var _hoisted_25 = {
  class: "dialog-footer"
};
import { systemType } from "@/constants";
import { ref, watch, watchEffect } from "vue";
import moment from "moment";
import { set_client_user, get_sing_in, set_visit_log_for_app, client, product_class, visit_log_get_client_info, get_client_project, get_visit_log_for_app } from "@/api/apis";
import { useUserStore } from "@/store/user";
import { ElMessage, ElMessageBox } from "element-plus";
import _ from "lodash";
import { useDicStore } from "@/store/dictionary";
import { phone_reg } from "@/util";
export default {
  __name: 'addVisitDailog',
  props: ["id", "isShow", "info", "title", "type"],
  emits: ["close", "onSetSuccess"],
  setup(__props, _ref) {
    var {
      emit: __emit
    } = _ref;
    var isNotClick = ref(false);
    var disStore = useDicStore();
    var props = __props;
    var emit = __emit;
    var userStore = useUserStore();
    var ruleFormRef = ref(null);
    var show_goods_class_select_popup = ref(false);
    var default_client = {
      title: "",
      //主题(标题)
      wait_type: "",
      //待办类型
      visit_way: "日常拜访",
      //拜访方式
      client_name: "",
      //客户姓名
      client_id: "0",
      //客户id 因洽谈记录增
      client_contacts: "",
      //联系人姓名
      client_user_id: "",
      //联系人姓名
      start_time: new Date(),
      //开始时间(时间戳 秒)
      content: "",
      //内容(议题)
      talk_log: "",
      //洽谈记录
      follow_event: "",
      //跟进事项
      end_time: "",
      //计划完成时间(结束时间)
      address: "",
      //单位地址
      remark: "",
      //说明
      img_file_id: [],
      img: "",
      is_subsidy: 0,
      follow_user_id: "",
      // 跟进人
      follow_user: "",
      is_clue: Number(1),
      to_clue: [],
      business: [],
      product_class: [],
      client_project_id: null,
      client_project_name: null,
      client_contacts_phone: null
    };
    var form = ref();
    form.value = Object.assign({}, default_client);
    var visit_type = ref("");

    /**
     * 数据字典
     */
    var dic_data = reactive({
      thread_status_list: [],
      // 线索状态
      source_list: [] // 线索来源
    });
    disStore.get_dic("线索状态").then(res => {
      if (!res) return;
      dic_data.thread_status_list = res.filter(item => item.full_name != "无效线索");
    });
    // 新增线索

    var clueForm = ref();
    //clueForm.value = Object.assign({}, default_clue);
    var clue_rules = {
      thread_status: [{
        required: "true",
        message: "请选择线索状态",
        trigger: ["blur", "change"]
      }],
      title: [{
        required: "true",
        message: "请输入客户项目",
        trigger: ["blur", "change"]
      }],
      cate: [{
        required: "true",
        message: "请选择产品分类",
        trigger: ["blur", "change"]
      }],
      income: [{
        required: "true",
        message: "请输入预计收入",
        trigger: ["blur", "change"]
      }],
      complete_time: [{
        required: "true",
        message: "请输入预计完成时间",
        trigger: ["blur", "change"]
      }]
    };
    var cateList = ref([]);
    var cateNaList = ref([{
      id: -999,
      name: "NA"
    }]);
    var getCate = () => {
      product_class({
        pid: 75
      }).then(res => {
        var _res$data;
        var data = (res === null || res === void 0 || (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.data) || [];
        cateList = data;
        cateNaList.value = cateNaList.value.concat(data).reverse();
        console.log("cateNaList", cateNaList.value);
      });
    };
    var refClue = ref("");
    var handle_add_clue = () => {
      isNotClick.value = true;
      refClue.value.validate(valid => {
        if (valid) {
          clueForm.value.checked = false;
          show_goods_class_select_popup.value = false;
          var class_ids = [];
          var class_name = [];
          clueForm.value.cate.map(item => {
            var s = item.split(",");
            class_ids.push(s[0]);
            class_name.push(s[1]);
          });
          clueForm.value.class_ids = class_ids.join(",");
          clueForm.value.class_name = class_name;
          clueForm.value.complete_time = moment(clueForm.value.complete_time).format("YYYY-MM-DD");
          form.value.to_clue.push(clueForm.value);
          isNotClick.value = false;
        } else {
          isNotClick.value = false;
        }
      });
    };
    // 表单验证方法
    function validatePhone(rule, value, callback) {
      if (value === "") {
        callback(new Error("请输入手机号"));
      } else if (!phone_reg(value)) {
        callback(new Error("手机号格式错误"));
      } else {
        callback();
      }
    }
    var showCatePop = () => {
      if (!form.value.client_project_id) {
        ElMessage({
          type: "warning",
          message: "请先选择客户项目"
        });
      } else {
        show_goods_class_select_popup.value = true;
        clueForm.value = {
          thread_status: "未处理",
          title: form.value.client_project_name,
          income: "",
          class_ids: "",
          complete_time: ""
        };
        //clueForm.value.title = form.value.client_project_name;
      }
    };
    var changeCheckbox = (e, index) => {
      form.value.to_clue[index].checked = e;
    };
    // 删除线索
    var deleteClue = () => {
      console.log(form.value.to_clue);
      var index = form.value.to_clue.findIndex(x => x.checked == true);
      if (index != -1) {
        ElMessageBox.confirm("是否删除选中线索？", "温馨提示", {
          confirmButtonText: "确认",
          cancelButtonText: "取消",
          type: "提示"
        }).then(() => {
          form.value.to_clue = form.value.to_clue.filter(item => !item.checked);
        });
      } else {
        ElMessage({
          type: "warning",
          message: "您尚未选择任何线索"
        });
      }
    };
    var changeCate = e => {};
    var selectLable = ref("");
    /**
     * 新增联系人
     */
    var default_contract = {
      name: "",
      phone: ""
    };
    var contracts_form = ref("");
    contracts_form.value = Object.assign({}, default_contract);
    var dialogFormVisible = ref(false);
    var refContract = ref("");
    var contract_rules = {
      name: [{
        required: "true",
        message: "请输入姓名",
        trigger: ["blur", "change"]
      }],
      phone: [{
        validator: validatePhone,
        required: true,
        trigger: "blur"
      }]
    };
    var handle_add_client = () => {
      if (!form.value.client_id) {
        ElMessage({
          type: "warning",
          message: "请选择客户"
        });
        return false;
      }
      refContract.value.validate(valid => {
        if (valid) {
          var obj = _.cloneDeep(contracts_form.value);
          obj.client_name = form.value.client_name;
          obj.client_id = form.value.client_id;
          set_client_user(obj, "post").then(res => {
            if (res.code == 200) {
              ElMessage({
                type: "success",
                message: "添加成功"
              });
              Object.prototype.toString.call(client_contracts_list.value) == "[object Array]" && client_contracts_list.value.unshift({
                name: contracts_form.value.name
              });
              form.value.client_contacts = contracts_form.value.name;
              form.value.client_contacts_phone = contracts_form.value.phone;
              form.value.client_user_id = res.data.id;
              dialogFormVisible.value = false;
            }
          });
        }
      });
    };
    var changeClientContacts = val => {
      form.value.client_contacts = val.name;
      form.value.client_user_id = val.id;
      form.value.client_contacts_phone = val.phone;
    };

    //产品类型选择
    var changeProductClass = e => {
      console.log(e);
      form.value.product_class = form.value.product_class.filter(item => {
        return item != "NA";
      });
      // if (!form.value.product_class.length) {
      //   form.value.product_class = ["NA"];
      // }
    };
    var focusProductClass = () => {
      if (form.value.product_class.length == 1 && form.value.product_class[0] == "NA") {
        form.value.product_class = [];
      }
    };
    watch(() => {
      return dialogFormVisible.value;
    }, val => {
      if (!val) {
        contracts_form.value = Object.assign({}, default_contract);
        refContract.value.resetFields();
      } else {}
    });

    // console.log("====================");

    var rules = {
      client_project_id: [{
        required: "true",
        message: "请选择客户项目",
        trigger: ["blur", "change"]
      }],
      start_time: [{
        required: "true",
        message: "请选择开始时间",
        trigger: ["blur", "change"]
      }],
      end_time: [{
        required: "true",
        message: "请选择结束时间",
        trigger: ["blur", "change"]
      }],
      client_name: [{
        required: "true",
        message: "请选择客户",
        trigger: ["blur", "change"]
      }],
      client_contacts: [{
        required: "true",
        message: "请选择联系人",
        trigger: ["blur", "change"]
      }],
      visit_way: [{
        required: "true",
        message: "请输入拜访方式",
        trigger: ["blur", "change"]
      }],
      address: [{
        required: "true",
        message: "请选择打卡记录",
        trigger: ["blur", "change"]
      }],
      product_class: [{
        required: "true",
        message: "请选择产品分类",
        trigger: ["blur", "change"]
      }],
      talk_log: [{
        required: "true",
        message: "请输入洽谈记录",
        trigger: ["blur", "change"]
      }]
    };
    var isContacts = ref(false);
    /**
     * 弹窗的展示与关闭
     */
    var dialogVisible = ref(false);
    var is_show_dialog = ref(false);
    watch(() => {
      return is_show_dialog.value;
    }, val => {
      if (!val) {
        key_word.value = "";
      }
    });
    watch(() => {
      return dialogVisible.value;
    }, () => {
      if (!dialogVisible.value) {
        form.value = Object.assign({}, default_client);
        fileList.value = [];
        client_contracts_list.value = [];
        ruleFormRef.value.resetFields();
        emit("close");
      } else {
        getCate();
        props.info && init_from();
        userStore.getInfo().then(res => {
          if (!form.value.follow_user) {
            form.value.follow_user = userStore.info.name;
            form.value.follow_user_id = userStore.info.id;
          }
        });
      }
    });

    // watch(
    //   () => {
    //     return form.value.birthday;
    //   },
    //   (val) => {
    //     console.log("获取的生日是", form.value.birthday);
    //   }
    // );
    /**
     * 上传头像
     */
    var fileList = ref([]);
    var action = process.env.VUE_APP_BASE_URL + "/api/file/add_file";
    var headers = {
      "system-type": systemType,
      Authorization: "Bearer " + localStorage.getItem("token_blk")
    };
    var dialogImageUrl = ref("");
    var dialogVisible_img = ref(false);
    var handleAvatarSuccess = (response, uploadFile) => {
      if (response.code == 200) {
        // form.value.avatar = response.data.file_id;
        // imageUrl.value = response.data.file_url;
      }
    };
    var beforeAvatarUpload = file => {
      var fileType = file.name ? file.name.substring(file.name.lastIndexOf(".") + 1).toUpperCase() : "";
      if (fileType != "JPG" && fileType != "PNG") {
        // ElMessage.error("上传文件只能是JPG或者PNG格式!");
        ElMessage({
          type: "error",
          message: "上传文件只能是JPG或者PNG格式"
        });
      }
      return fileType == "JPG" || fileType == "PNG";
    };
    var handlePictureCardPreview = uploadFile => {
      dialogImageUrl.value = uploadFile.url;
      dialogVisible_img.value = true;
    };
    var handleRemove = (uploadFile, files) => {};
    /**
     * 编辑客户，初始化数据
     */
    var init_from = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(function* () {
        var res = null;
        if (props.title != '日程登记') {
          res = yield get_visit_log_for_app({
            id: props.info.id
          });
        }
        var obj = props.title == '日程登记' ? props.info : res.data.data || {};
        Object.keys(form.value).map(x => {
          if (obj.hasOwnProperty(x)) {
            form.value[x] = obj[x];
          }
        });
        // if (!form.value.product_class.length) {
        //   form.value.product_class = ["NA"];
        // }
        if (form.value.client_id) {
          getClientProjects(form.value.client_id);
          cur_client_id.value = form.value.client_id;
        }
        if (!form.value.product_class.length) {
          form.value.product_class = ["NA"];
        }
        console.log("client_contacts", form.value.client_contacts);
        client({
          company: form.value.client_name
        }).then(res => {
          if (res.code == 200 && form.value.client_name) {
            // if (res.data.list.length == 0) {
            //   form.value.client_name = "";
            //   form.value.client_id = "";
            //   form.value.client_contacts = "";
            // }
            client_contracts_list.value = res.data.list && res.data.list.length != 0 && res.data.list[0].client_users;
          }
        });
        form.value.end_time = new Date(form.value.end_time * 1000);
        form.value.start_time = new Date(form.value.start_time * 1000);
        // form.value.img = (form.value.img && JSON.parse(form.value.img)) || [];
        console.log("form.value", form.value.img);
        if (form.value.img) {
          // console.log("有img");
          console.log("form.value", form.value.img);
          if (typeof form.value.img === "string") {
            form.value.img = JSON.parse(form.value.img);
          }
        } else {
          // console.log("img是空");
          form.value.img = [];
        }
        fileList.value = form.value.img;

        // form.value.client_name = obj.client_info.company;
        // imageUrl.value = obj.file_url;
        //   file_list.value = [{ name: "头像", url: obj.file_url }];
        // console.log("打印form", form.value);
      });
      return function init_from() {
        return _ref2.apply(this, arguments);
      };
    }();
    watch(() => {
      return props.info;
    }, () => {
      if (!props.info) {
        form.value = Object.assign({}, default_client);
        form.value.visit_way = "日常拜访";
        fileList.value = [];
      } else {
        init_from();
      }
    });
    //获取客户项目
    var client_project_list = ref([]);
    var getClientProjects = function getClientProjects(id) {
      var is_default = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      get_client_project({
        client_id: id
      }).then(res => {
        if (res.code == 200) {
          client_project_list.value = res.data || [];
          form.value.client_project_name = client_project_list.value[0].project;
          console.log("client_project_name:", form.value.client_project_name);
          if (is_default) {
            var _client_project_list$;
            form.value.client_project_id = (_client_project_list$ = client_project_list.value[0]) === null || _client_project_list$ === void 0 ? void 0 : _client_project_list$.id;
          }
          getVisitLogClientInfo();
        }
      });
    };
    var showDialog = ref(false);
    //新增客户项目
    var addClientProject = () => {
      if (!form.value.client_name) {
        ElMessage({
          type: "error",
          message: "请先选择客户"
        });
        return;
      }
      showDialog.value = true;
    };
    var handle_close_client = type => {
      showDialog.value = false;
      getClientProjects(cur_client_id.value, type == "add" ? true : false);
    };
    var cur_client_id = ref(null);
    /**
     * 选择客户
     */
    var data_type = ref(""); // 进行选择数据的字段
    var key_word = ref(""); // 关键字查询

    var client_contracts_list = ref([]);
    var select_data = val => {
      data_type.value = val;
      is_show_dialog.value = true;
    };
    var get_select_item = val => {
      if (!val.client_level) {
        ElMessage({
          type: "error",
          message: "请先维护客户类型"
        });
        return;
      }
      is_show_dialog.value = false;
      if (data_type.value == "客户") {
        if (val.company != form.value.client_name) {
          form.value.client_name = val.company;
          form.value.client_id = val.id;
          form.value.client_contacts = "";
          client_contracts_list.value = val.client_users || [];
          getClientProjects(val.id, true);
          cur_client_id.value = val.id;
        }
      }
    };
    var changeClientProject = () => {
      getVisitLogClientInfo();
    };
    //获取客户信息-线索/商机
    var getVisitLogClientInfo = () => {
      visit_log_get_client_info({
        client_id: form.value.client_id,
        client_project_id: form.value.client_project_id
      }).then(res => {
        if (res.code == 200) {
          var _res$data2, _res$data3;
          console.log("data:", res.data);
          form.value.business = (res === null || res === void 0 || (_res$data2 = res.data) === null || _res$data2 === void 0 ? void 0 : _res$data2.business) || [];
          form.value.to_clue = (res === null || res === void 0 || (_res$data3 = res.data) === null || _res$data3 === void 0 ? void 0 : _res$data3.clue) || [];
        }
      });
    };
    var changeEndTime = e => {
      if (form.value.start_time) {
        var start_time = new Date(form.value.start_time).getTime() / 1000;
        var end_time = new Date(e).getTime() / 1000;
        if (end_time < start_time) {
          ElMessage({
            type: "warning",
            message: "结束时间不能小于开始时间"
          });
          form.value.end_time = "";
        }
      }
    };
    var changeStartTime = e => {
      if (form.value.end_time) {
        var start_time = new Date(e).getTime() / 1000;
        var end_time = new Date(form.value.end_time).getTime() / 1000;
        if (end_time < start_time) {
          ElMessage({
            type: "warning",
            message: "开始时间不能大于结束时间"
          });
          form.value.start_time = "";
        }
      }
    };
    /**
     * 提交
     */
    var onSubmit = () => {
      ruleFormRef.value.validate(valid => {
        if (valid) {
          // form.value.salename = dic_data.sales_user_list.find(
          //   (x) => x.id == form.value.userid
          // )?.name;

          var obj = _.cloneDeep(form.value);
          if (obj.client_name != "NA" && obj.is_clue && !obj.to_clue.length) {
            ElMessage({
              type: "warning",
              message: "请添加线索"
            });
            return;
          }
          var method = "post";
          if (props.id) {
            method = "put";
            obj.id = props.id;
          }
          obj.end_time = obj.end_time && obj.end_time.getTime() / 1000;
          obj.start_time = obj.start_time && obj.start_time.getTime() / 1000;
          obj["img_file_id"] = fileList.value.map(x => {
            if (x.response) {
              return x.response.data.file_id;
            } else {}
          }) || [];
          obj.img = JSON.stringify(fileList.value.map(x => {
            if (x.response) {
              return {
                id: x.response.data.file_id,
                url: x.response.data.file_url
              };
            } else {
              return {
                id: x.id,
                url: x.url
              };
            }
          }));
          if (props.info && !props.id) {
            obj.calendar_id = props.info.id;
          }
          obj["product_class"] = obj["product_class"].filter(item => {
            return item != "NA" && item != -999;
          });
          if (!obj.calendar_id && !obj.id) {
            obj["type"] = visit_type.value;
          }
          console.log({
            obj
          });
          set_visit_log_for_app(obj, method).then(res => {
            if (res.code == 200) {
              ElMessage({
                type: "success",
                message: props.id ? "编辑成功" : "新增成功"
              });
              dialogVisible.value = false;
              emit("onSetSuccess");
            }
          });
        }
      });
    };

    /**
     * 数据字典
     */
    var visit_list = ref("");
    disStore.get_visit_list().then(res => {
      visit_list.value = res;
    });
    /**
     * 申请报销
     */
    var handle_money = () => {
      ElMessage({
        type: "info",
        message: "该功能建设中"
      });
    };
    /**
     * 打卡记录
     */
    // watch(
    //   () => {
    //     return form.value.start_time;
    //   },
    //   () => {
    //     let obj = {
    //       time: new Date(form.value.start_time).toLocaleString(),
    //       page: 1,
    //       limit: 10,
    //     };
    //     get_sing_in_fn(obj);
    //   }
    // );

    var signIn_list = ref([]);
    var get_sing_in_fn = obj => {
      get_sing_in(obj).then(res => {
        if (res.code == 200) {
          signIn_list.value = res.data.data;
        }
      });
    };
    watchEffect(() => {
      dialogVisible.value = props.isShow;
      if (form.value.start_time) {
        var obj = {
          time: new Date(form.value.start_time).toLocaleString(),
          page: 1,
          limit: 10
        };
        get_sing_in_fn(obj);
      }
      if (props.type) {
        visit_type.value = props.type;
        if (visit_type.value == 2) {
          form.value.product_class = [44];
        }
      }
    });
    watch(() => {
      return form.value.client_name;
    }, val => {
      console.log({
        val
      });
      isContacts.value = val != "NA" ? true : false;
      console.log("isContacts", isContacts.value);
    });
    var isAddress = ref(false);
    watch(() => {
      return form.value.visit_way;
    }, val => {
      isAddress.value = val == "上门拜访" ? true : false;
    });

    //是否展开线索
    var is_expand = ref(true);
    var handleExplan = () => {
      is_expand.value = !is_expand.value;
    };
    //是否展开商机
    var is_expandBusiness = ref(true);
    var handleBusiness = () => {
      is_expandBusiness.value = !is_expandBusiness.value;
    };
    return (_ctx, _cache) => {
      var _component_el_date_picker = __unplugin_components_0;
      var _component_el_form_item = __unplugin_components_1;
      var _component_el_col = __unplugin_components_2;
      var _component_el_row = __unplugin_components_3;
      var _component_el_input = __unplugin_components_4;
      var _component_el_button = __unplugin_components_5;
      var _component_el_option = __unplugin_components_6;
      var _component_el_select = __unplugin_components_7;
      var _component_el_radio = __unplugin_components_8;
      var _component_el_radio_group = __unplugin_components_9;
      var _component_ArrowUpBold = _resolveComponent("ArrowUpBold");
      var _component_el_icon = __unplugin_components_10;
      var _component_ArrowDownBold = _resolveComponent("ArrowDownBold");
      var _component_el_checkbox = __unplugin_components_11;
      var _component_Plus = _resolveComponent("Plus");
      var _component_el_upload = __unplugin_components_12;
      var _component_el_dialog = __unplugin_components_13;
      var _component_el_form = __unplugin_components_14;
      var _component_select_data = __unplugin_components_15;
      var _component_client_project_dialog = __unplugin_components_16;
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", null, [_createVNode(_component_el_dialog, {
        modelValue: dialogVisible.value,
        "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => dialogVisible.value = $event),
        title: _unref(props).title,
        style: {
          "width": "700px"
        },
        "destroy-on-close": true
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_23, [_createVNode(_component_el_button, {
          onClick: _cache[15] || (_cache[15] = $event => dialogVisible.value = false)
        }, {
          default: _withCtx(() => _cache[52] || (_cache[52] = [_createTextVNode("取消")])),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: onSubmit,
          color: "#248f83"
        }, {
          default: _withCtx(() => _cache[53] || (_cache[53] = [_createTextVNode(" 确定 ")])),
          _: 1
        })])]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          ref_key: "ruleFormRef",
          ref: ruleFormRef,
          model: _unref(form),
          "label-position": "right",
          rules: rules,
          "label-width": "100px"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_row, {
            gutter: 20
          }, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_cache[29] || (_cache[29] = _createElementVNode("div", {
                class: "grid-content ep-bg-purple"
              }, null, -1)), _createVNode(_component_el_form_item, {
                label: "开始时间",
                prop: "start_time"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_date_picker, {
                  modelValue: _unref(form).start_time,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _unref(form).start_time = $event),
                  type: "datetime",
                  placeholder: "请输入开始时间",
                  format: "YYYY-MM-DD HH:mm",
                  onChange: changeStartTime,
                  style: {
                    "width": "100%"
                  }
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_cache[30] || (_cache[30] = _createElementVNode("div", {
                class: "grid-content ep-bg-purple"
              }, null, -1)), _createVNode(_component_el_form_item, {
                label: "结束时间",
                prop: "end_time"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_date_picker, {
                  modelValue: _unref(form).end_time,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _unref(form).end_time = $event),
                  type: "datetime",
                  style: {
                    "width": "100%"
                  },
                  format: "YYYY-MM-DD HH:mm",
                  placeholder: "请输入结束时间",
                  onChange: changeEndTime
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, {
            gutter: 20
          }, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_cache[32] || (_cache[32] = _createElementVNode("div", {
                class: "grid-content ep-bg-purple"
              }, null, -1)), _createVNode(_component_el_form_item, {
                label: "客户",
                prop: "client_name"
              }, {
                default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_input, {
                  modelValue: _unref(form).client_name,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _unref(form).client_name = $event),
                  autocomplete: "off",
                  style: {
                    "width": "100%"
                  },
                  disabled: ""
                }, null, 8, ["modelValue"])]), _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: _cache[3] || (_cache[3] = $event => select_data('客户')),
                  color: "#248f83"
                }, {
                  default: _withCtx(() => _cache[31] || (_cache[31] = [_createTextVNode("选择")])),
                  _: 1
                })])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_cache[33] || (_cache[33] = _createElementVNode("div", {
                class: "grid-content ep-bg-purple"
              }, null, -1)), _createVNode(_component_el_form_item, {
                label: "客户项目",
                prop: "client_project_id"
              }, {
                default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createVNode(_component_el_select, {
                  modelValue: _unref(form).client_project_id,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => _unref(form).client_project_id = $event),
                  filterable: "",
                  placeholder: "请选择客户项目",
                  style: {
                    "width": "90%"
                  },
                  "value-key": "FNumber",
                  onChange: changeClientProject
                }, {
                  default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(client_project_list.value, item => {
                    return _openBlock(), _createBlock(_component_el_option, {
                      key: item.id,
                      label: item.project,
                      value: item.id
                    }, null, 8, ["label", "value"]);
                  }), 128))]),
                  _: 1
                }, 8, ["modelValue"]), _createElementVNode("span", {
                  class: "client_add iconfont icon-a-zengjiatianjiajiahaoduo",
                  onClick: addClientProject
                })])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_cache[34] || (_cache[34] = _createElementVNode("div", {
                class: "grid-content ep-bg-purple"
              }, null, -1)), _createVNode(_component_el_form_item, {
                label: "联系人",
                prop: "client_contacts",
                required: _unref(isContacts)
              }, {
                default: _withCtx(() => [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createVNode(_component_el_select, {
                  modelValue: _unref(form).client_contacts,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => _unref(form).client_contacts = $event),
                  class: "m-2",
                  placeholder: "",
                  filterable: "",
                  style: {
                    "width": "100%"
                  },
                  onChange: changeClientContacts
                }, {
                  default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(client_contracts_list.value, item => {
                    return _openBlock(), _createBlock(_component_el_option, {
                      key: item.id,
                      label: item.name,
                      value: item
                    }, null, 8, ["label", "value"]);
                  }), 128))]),
                  _: 1
                }, 8, ["modelValue"])]), _createElementVNode("span", {
                  class: "iconfont icon-tianjia1",
                  onClick: _cache[6] || (_cache[6] = $event => dialogFormVisible.value = true)
                })])]),
                _: 1
              }, 8, ["required"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, {
            gutter: 20
          }, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_cache[35] || (_cache[35] = _createElementVNode("div", {
                class: "grid-content ep-bg-purple"
              }, null, -1)), _createVNode(_component_el_form_item, {
                label: "拜访方式",
                prop: "visit_way"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_select, {
                  modelValue: _unref(form).visit_way,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => _unref(form).visit_way = $event),
                  class: "m-2",
                  placeholder: "",
                  filterable: "",
                  style: {
                    "width": "100%"
                  }
                }, {
                  default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visit_list.value, item => {
                    return _openBlock(), _createBlock(_component_el_option, {
                      key: item.id,
                      label: item.full_name,
                      value: item.full_name
                    }, null, 8, ["label", "value"]);
                  }), 128))]),
                  _: 1
                }, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_cache[36] || (_cache[36] = _createElementVNode("div", {
                class: "grid-content ep-bg-purple"
              }, null, -1)), _createVNode(_component_el_form_item, {
                label: "打卡记录",
                prop: "address",
                required: _unref(isAddress)
              }, {
                default: _withCtx(() => [_createVNode(_component_el_select, {
                  modelValue: _unref(form).address,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => _unref(form).address = $event),
                  class: "m-2",
                  placeholder: "",
                  filterable: "",
                  style: {
                    "width": "100%"
                  }
                }, {
                  default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(signIn_list), item => {
                    return _openBlock(), _createBlock(_component_el_option, {
                      key: item.id,
                      label: item.address,
                      value: item.address
                    }, null, 8, ["label", "value"]);
                  }), 128))]),
                  _: 1
                }, 8, ["modelValue"])]),
                _: 1
              }, 8, ["required"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, {
            gutter: 20
          }, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 24
            }, {
              default: _withCtx(() => [_cache[37] || (_cache[37] = _createElementVNode("div", {
                class: "grid-content ep-bg-purple"
              }, null, -1)), _createVNode(_component_el_form_item, {
                label: "产品分类",
                prop: "product_class"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_select, {
                  modelValue: _unref(form).product_class,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => _unref(form).product_class = $event),
                  multiple: "",
                  placeholder: "请选择产品分类",
                  style: {
                    "width": "100%"
                  },
                  onChange: changeProductClass
                }, {
                  default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(cateNaList), item => {
                    return _openBlock(), _createBlock(_component_el_option, {
                      key: item.id,
                      label: item.name,
                      value: item.id
                    }, null, 8, ["label", "value"]);
                  }), 128))]),
                  _: 1
                }, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, {
            gutter: 20
          }, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 24
            }, {
              default: _withCtx(() => [_cache[38] || (_cache[38] = _createElementVNode("div", {
                class: "grid-content ep-bg-purple"
              }, null, -1)), _createVNode(_component_el_form_item, {
                label: "洽谈记录",
                prop: "talk_log"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  type: "textarea",
                  modelValue: _unref(form).talk_log,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => _unref(form).talk_log = $event),
                  autocomplete: "off",
                  rows: 5
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _unref(form).client_name != 'NA' ? (_openBlock(), _createBlock(_component_el_row, {
            key: 0,
            gutter: 20
          }, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_cache[41] || (_cache[41] = _createElementVNode("div", {
                class: "grid-content ep-bg-purple"
              }, null, -1)), _createVNode(_component_el_form_item, {
                label: "新增线索",
                required: ""
              }, {
                default: _withCtx(() => [_createVNode(_component_el_radio_group, {
                  modelValue: _unref(form).is_clue,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => _unref(form).is_clue = $event),
                  class: "ml-4"
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_radio, {
                    label: 1
                  }, {
                    default: _withCtx(() => _cache[39] || (_cache[39] = [_createTextVNode("是")])),
                    _: 1
                  }), _createVNode(_component_el_radio, {
                    label: 0
                  }, {
                    default: _withCtx(() => _cache[40] || (_cache[40] = [_createTextVNode("否")])),
                    _: 1
                  })]),
                  _: 1
                }, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_cache[42] || (_cache[42] = _createElementVNode("div", {
                class: "grid-content ep-bg-purple"
              }, null, -1)), _createElementVNode("span", {
                class: "exchange-clue",
                onClick: handleExplan
              }, [_createTextVNode(_toDisplayString(_unref(is_expand) ? "收起线索" : "展开线索"), 1), _unref(is_expand) ? (_openBlock(), _createBlock(_component_el_icon, {
                key: 0,
                class: "icon-arrow"
              }, {
                default: _withCtx(() => [_createVNode(_component_ArrowUpBold)]),
                _: 1
              })) : (_openBlock(), _createBlock(_component_el_icon, {
                key: 1,
                class: "icon-arrow"
              }, {
                default: _withCtx(() => [_createVNode(_component_ArrowDownBold)]),
                _: 1
              }))])]),
              _: 1
            })]),
            _: 1
          })) : _createCommentVNode("", true), _unref(form).is_clue && _unref(form).client_name != 'NA' ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: _normalizeClass(["clueBox", [_unref(is_expand) ? '' : 'hide']])
          }, [_createElementVNode("div", {
            class: "clue-top"
          }, [_createElementVNode("span", {
            class: "iconfont icon-tianjia1",
            onClick: showCatePop
          }, _cache[43] || (_cache[43] = [_createElementVNode("text", {
            class: "icon-text"
          }, null, -1)])), _createElementVNode("span", {
            class: "iconfont confont icon-shanchu",
            onClick: deleteClue
          })]), _createElementVNode("div", _hoisted_6, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(form).to_clue, (item, index) => {
            return _openBlock(), _createElementBlock("div", {
              class: "item-clue",
              key: index
            }, [_createVNode(_component_el_checkbox, {
              label: "",
              value: item.checked,
              onChange: e => {
                changeCheckbox(e, index);
              }
            }, null, 8, ["value", "onChange"]), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, "客户项目：" + _toDisplayString(item.title), 1)]), _createElementVNode("div", _hoisted_10, "线索状态：" + _toDisplayString(item.thread_status), 1), item.thread_status != '无效线索' ? (_openBlock(), _createElementBlock("div", _hoisted_11, " 预计收入：￥" + _toDisplayString(item.income), 1)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_12, " 预计完成时间：" + _toDisplayString(item.complete_time), 1), item.id ? (_openBlock(), _createElementBlock("div", _hoisted_13, [_cache[44] || (_cache[44] = _createTextVNode(" 产品类别：")), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.class_ids_list, (m, t) => {
              return _openBlock(), _createElementBlock("text", {
                class: "cate-class",
                key: t
              }, _toDisplayString(m.name), 1);
            }), 128))])) : (_openBlock(), _createElementBlock("div", _hoisted_14, [_cache[45] || (_cache[45] = _createTextVNode(" 产品类别：")), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.class_name, (m, t) => {
              return _openBlock(), _createElementBlock("text", {
                class: "cate-class",
                key: t
              }, _toDisplayString(m), 1);
            }), 128))]))])]);
          }), 128))])], 2)) : _createCommentVNode("", true), _unref(form).business.length && _unref(form).client_id ? (_openBlock(), _createElementBlock("div", _hoisted_15, [_cache[46] || (_cache[46] = _createElementVNode("div", {
            class: "title"
          }, "商机列表", -1)), _createElementVNode("span", {
            class: "exchange-clue",
            onClick: handleBusiness
          }, [_createTextVNode(_toDisplayString(_unref(is_expandBusiness) ? "收起商机" : "展开商机"), 1), _unref(is_expandBusiness) ? (_openBlock(), _createBlock(_component_el_icon, {
            key: 0,
            class: "icon-arrow"
          }, {
            default: _withCtx(() => [_createVNode(_component_ArrowUpBold)]),
            _: 1
          })) : (_openBlock(), _createBlock(_component_el_icon, {
            key: 1,
            class: "icon-arrow"
          }, {
            default: _withCtx(() => [_createVNode(_component_ArrowDownBold)]),
            _: 1
          }))])])) : _createCommentVNode("", true), _createElementVNode("div", {
            class: _normalizeClass(["clue-list", [_unref(is_expandBusiness) ? '' : 'hide']])
          }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(form).business, (item, index) => {
            return _openBlock(), _createElementBlock("div", {
              class: "item-clue",
              key: index
            }, [_createElementVNode("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, [_createElementVNode("div", _hoisted_18, "客户项目：" + _toDisplayString(item.title), 1)]), _createElementVNode("div", _hoisted_19, "商机状态：" + _toDisplayString(item.thread_status), 1), item.thread_status != '无效线索' ? (_openBlock(), _createElementBlock("div", _hoisted_20, " 预计收入：￥" + _toDisplayString(item.income), 1)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_21, " 预计签单时间：" + _toDisplayString(item.complete_time), 1)])]);
          }), 128))], 2), _cache[51] || (_cache[51] = _createElementVNode("div", {
            class: "title"
          }, "选填选项", -1)), _createVNode(_component_el_row, {
            gutter: 20
          }, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_cache[47] || (_cache[47] = _createElementVNode("div", {
                class: "grid-content ep-bg-purple"
              }, null, -1)), _createVNode(_component_el_form_item, {
                label: "申请报销"
              }, {
                default: _withCtx(() => [_createElementVNode("span", {
                  class: "iconfont icon-baoxiao",
                  onClick: handle_money
                })]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_cache[48] || (_cache[48] = _createElementVNode("div", {
                class: "grid-content ep-bg-purple"
              }, null, -1)), _createVNode(_component_el_form_item, {
                label: "跟进人"
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(form).follow_user), 1)]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, {
            gutter: 20
          }, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 24
            }, {
              default: _withCtx(() => [_cache[49] || (_cache[49] = _createElementVNode("div", {
                class: "grid-content ep-bg-purple"
              }, null, -1)), _createVNode(_component_el_form_item, {
                label: "上传图片"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_upload, {
                  "file-list": fileList.value,
                  "onUpdate:fileList": _cache[12] || (_cache[12] = $event => fileList.value = $event),
                  action: action,
                  headers: headers,
                  data: {
                    content_type: 1
                  },
                  "list-type": "picture-card",
                  "on-preview": handlePictureCardPreview,
                  "on-remove": handleRemove,
                  "on-success": handleAvatarSuccess,
                  "before-upload": beforeAvatarUpload
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [_createVNode(_component_Plus)]),
                    _: 1
                  })]),
                  _: 1
                }, 8, ["file-list"]), _createVNode(_component_el_dialog, {
                  modelValue: dialogVisible_img.value,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => dialogVisible_img.value = $event)
                }, {
                  default: _withCtx(() => [_createElementVNode("img", {
                    "w-full": "",
                    src: dialogImageUrl.value,
                    alt: "Preview Image"
                  }, null, 8, _hoisted_22)]),
                  _: 1
                }, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, {
            gutter: 20
          }, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 24
            }, {
              default: _withCtx(() => [_cache[50] || (_cache[50] = _createElementVNode("div", {
                class: "grid-content ep-bg-purple"
              }, null, -1)), _createVNode(_component_el_form_item, {
                label: "备注"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  type: "textarea",
                  modelValue: _unref(form).remark,
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => _unref(form).remark = $event),
                  autocomplete: "off"
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }, 8, ["model"])]),
        _: 1
      }, 8, ["modelValue", "title"]), _createVNode(_component_select_data, {
        onClose: _cache[17] || (_cache[17] = $event => is_show_dialog.value = false),
        isShow: is_show_dialog.value,
        data_type: data_type.value,
        key_word: key_word.value,
        dialog: "",
        isNa: true,
        visit_type: _unref(visit_type),
        onOnSelectItem: get_select_item
      }, null, 8, ["isShow", "data_type", "key_word", "visit_type"])]), _createVNode(_component_el_dialog, {
        modelValue: dialogFormVisible.value,
        "onUpdate:modelValue": _cache[21] || (_cache[21] = $event => dialogFormVisible.value = $event),
        title: "新增联系人",
        style: {
          "width": "500px"
        }
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_24, [_createVNode(_component_el_button, {
          onClick: _cache[20] || (_cache[20] = $event => dialogFormVisible.value = false)
        }, {
          default: _withCtx(() => _cache[54] || (_cache[54] = [_createTextVNode("取消")])),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: handle_add_client,
          color: "#248f83"
        }, {
          default: _withCtx(() => _cache[55] || (_cache[55] = [_createTextVNode(" 确定 ")])),
          _: 1
        })])]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          model: contracts_form.value,
          ref_key: "refContract",
          ref: refContract,
          rules: contract_rules
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "姓名",
            "label-width": 80,
            prop: "name"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: contracts_form.value.name,
              "onUpdate:modelValue": _cache[18] || (_cache[18] = $event => contracts_form.value.name = $event),
              autocomplete: "off"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "手机号",
            "label-width": 80,
            prop: "phone"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: contracts_form.value.phone,
              "onUpdate:modelValue": _cache[19] || (_cache[19] = $event => contracts_form.value.phone = $event),
              autocomplete: "off"
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model"])]),
        _: 1
      }, 8, ["modelValue"]), _unref(show_goods_class_select_popup) ? (_openBlock(), _createBlock(_component_el_dialog, {
        key: 0,
        modelValue: _unref(show_goods_class_select_popup),
        "onUpdate:modelValue": _cache[28] || (_cache[28] = $event => _isRef(show_goods_class_select_popup) ? show_goods_class_select_popup.value = $event : show_goods_class_select_popup = $event),
        title: "新增线索",
        style: {
          "width": "500px"
        }
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_25, [_createVNode(_component_el_button, {
          onClick: _cache[27] || (_cache[27] = $event => _isRef(show_goods_class_select_popup) ? show_goods_class_select_popup.value = false : show_goods_class_select_popup = false)
        }, {
          default: _withCtx(() => _cache[56] || (_cache[56] = [_createTextVNode("取消")])),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: handle_add_clue,
          color: "#248f83",
          disabled: _unref(isNotClick)
        }, {
          default: _withCtx(() => _cache[57] || (_cache[57] = [_createTextVNode(" 确定 ")])),
          _: 1
        }, 8, ["disabled"])])]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          model: clueForm.value,
          ref_key: "refClue",
          ref: refClue,
          rules: clue_rules,
          "label-width": 110
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "线索状态",
            prop: "thread_status"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: clueForm.value.thread_status,
              "onUpdate:modelValue": _cache[22] || (_cache[22] = $event => clueForm.value.thread_status = $event),
              class: "m-2",
              placeholder: "请选择线索状态",
              style: {
                "width": "100%"
              }
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(dic_data).thread_status_list, item => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: item.id,
                  label: item.full_name,
                  value: item.full_name
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "客户项目",
            prop: "title"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: clueForm.value.title,
              "onUpdate:modelValue": _cache[23] || (_cache[23] = $event => clueForm.value.title = $event),
              autocomplete: "off",
              placeholder: "请输入客户项目",
              disabled: ""
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "产品分类",
            prop: "cate"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: clueForm.value.cate,
              "onUpdate:modelValue": _cache[24] || (_cache[24] = $event => clueForm.value.cate = $event),
              multiple: "",
              placeholder: "请选择产品分类",
              style: {
                "width": "100%"
              },
              ref_key: "selectLable",
              ref: selectLable
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(cateList), item => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: item.id,
                  label: item.name,
                  value: item.id + ',' + item.name
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "预计收入",
            prop: "income"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: clueForm.value.income,
              "onUpdate:modelValue": _cache[25] || (_cache[25] = $event => clueForm.value.income = $event),
              autocomplete: "off",
              onBlur: _ctx.price_input,
              placeholder: "请输入预计收入",
              oninput: "value=value.replace(/[^0-9.]/g,'')"
            }, null, 8, ["modelValue", "onBlur"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "预计完成时间",
            prop: "complete_time"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_date_picker, {
              modelValue: clueForm.value.complete_time,
              "onUpdate:modelValue": _cache[26] || (_cache[26] = $event => clueForm.value.complete_time = $event),
              type: "date",
              placeholder: "请输入预计完成时间",
              format: "YYYY-MM-DD",
              style: {
                "width": "100%"
              }
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model"])]),
        _: 1
      }, 8, ["modelValue"])) : _createCommentVNode("", true), showDialog.value ? (_openBlock(), _createBlock(_component_client_project_dialog, {
        key: 1,
        isShow: showDialog.value,
        onOnClose: handle_close_client,
        id: cur_client_id.value
      }, null, 8, ["isShow", "id"])) : _createCommentVNode("", true)], 64);
    };
  }
};